
import {Routes, RouterModule} from "@angular/router";
import {SiteComponent} from "./site.component";
import {NgModule} from "@angular/core";
import {HomeComponent} from "./home/home.component";
import {PricingComponent} from "./pricing/pricing.component";
import {UseCasesComponent} from "./use-cases/use-cases.component";
import {UseCaseMainComponent} from "./use-cases/use-case/use-case-main.component";
import {FarmingComponent} from "./use-cases/farming/farming.component";
import {HeaderComponent} from "./header/header.component";
import {AutoMotiveComponent} from "./use-cases/automotive/automotive";
import {ConsumerElectronics} from "./use-cases/consumer-electronics/consumer.electronics";
import {ToggleButton} from "./home/toggle.directive";
import {SiteFooterComponent} from "./shared/site-footer";
import {PlatformComponent} from "./platform/platform.component";
import {PlatformMainComponent} from "./platform/main/platform.main.component";
import {ElectronComponent} from "./platform/electron/electron.component";
import {NeutronComponent} from "./platform/neutron/neutron.component";
import {NucleusComponent} from "./platform/nucleus/nucleus.component";
import {ElectronDetailsComponent} from "./platform/electron/electron-details.component";
import {GLOBAL_CONSTANTS} from "../global/global.constants";
const routes: Routes = [
  {
    path: '',
    component: SiteComponent,
    children: [
      {path:  '', component: HomeComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.DEFAULT}},
      {path: 'pricing', component: PricingComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.PRICING}},
      {path: 'use-cases', component: UseCasesComponent,
      children: [
        {path: '', component: UseCaseMainComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.USE_CASE}},
        {path: 'automotive', component: AutoMotiveComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.USE_CASE}},
        {path: 'farming', component: FarmingComponent, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.USE_CASE}},
        {path: 'consumer-electronics', component: ConsumerElectronics, data: {title: GLOBAL_CONSTANTS.PAGE_TITLE.USE_CASE}},
      ]
      },
      {path: 'platform', component: PlatformComponent,
        children: [
          {path: '', component:  PlatformMainComponent, data:{title: GLOBAL_CONSTANTS.PAGE_TITLE.PLATFORM},},
          {path: 'electron', component: ElectronComponent, data:{title: GLOBAL_CONSTANTS.PAGE_TITLE.ELECTRON},},
          {path: 'nucleus', component: NucleusComponent,data:{title: GLOBAL_CONSTANTS.PAGE_TITLE.NUCLEUS}},
          {path: 'neutron', component: NeutronComponent,data:{title: GLOBAL_CONSTANTS.PAGE_TITLE.NEUTRON}},
          {path: 'downloads', component: ElectronDetailsComponent, data:{title: GLOBAL_CONSTANTS.PAGE_TITLE.DOWNLOADS}}
        ]
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: [],
})
export class SiteRoutingModule { }

export let ROUTED_COMPONENTS = [
  SiteComponent,
  HomeComponent,
  UseCaseMainComponent,
  FarmingComponent,
  HeaderComponent,
  PricingComponent,
  UseCasesComponent,
  AutoMotiveComponent,
  ConsumerElectronics,
  ToggleButton,
  SiteFooterComponent,
  PlatformComponent,
  PlatformMainComponent,
  ElectronComponent,
  NeutronComponent,
  NucleusComponent,
  ElectronDetailsComponent

];



// WEBPACK FOOTER //
// ./src/app/site/site.routing.module.ts